import * as React from 'react'

export function ArchetypesDeskLamp(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M22.861 9.736c1.9-.638 2.267-.118.778 1.185-1.509 1.32-4.316 2.913-6.226 3.533-1.883.612-2.144.032-.624-1.271 1.498-1.286 4.2-2.818 6.072-3.447m-5.816 6.978c2.738-.758 6.671-2.992 8.723-4.952 1.038-.991 1.378-1.708 1.101-2.068C24.92 6.49 21.067 5.17 17.88 6.537c.047-.172.082-.35.082-.537a2 2 0 00-4 0c0 .983.711 1.797 1.647 1.965l-9.312 8.919a.963.963 0 00-.015 1.374l5.936 5.937c-.555.081-1.087.181-1.55.313-.975.282-1.527.63-1.669.991a.466.466 0 00-.037.187v.625c0 .064.011.124.037.188.146.375.74.735 1.77 1.02 2.325.641 6.053.641 8.381 0 1.031-.285 1.628-.645 1.774-1.02a.486.486 0 00.038-.188v-.625a.467.467 0 00-.038-.187c-.142-.361-.694-.709-1.665-.991-1.234-.354-2.88-.519-4.51-.502l-6.412-6.413 5.481-5.251a7.771 7.771 0 00.878 4.247c.16.432.951.512 2.35.125'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
